import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListQueryParameters } from '@lib/api';

import { IFsLprReadsParameters } from '../interfaces/lpr-reads-parameters.interface';
import { LprReadModel } from '../models/lpr-read.model';
import { LprReadsFieldsModel } from '../models/lpr-reads-fields.model';
import { LprReadsModel } from '../models/lpr-reads.model';
import { LprReasonResults } from '../models/lpr-reason-results.model';

@Injectable({ providedIn: 'root' })
export class FsLprReadsService {
  private _api: string;

  constructor(private readonly _httpClient: HttpClient) {
    this._api = localStorage.getItem('LPR_API') ?? '';
  }

  public getReasons(): Observable<LprReasonResults> {
    return this._httpClient.get<LprReasonResults>('/api/lpr/hits/reasons/');
  }

  public getReadsFields(): Observable<LprReadsFieldsModel> {
    if (!this._api) {
      console.warn('LPR API is disabled or not configured');
      return of(new LprReadsFieldsModel({}));
    }
    return this._httpClient
      .get(`${this._api}/api/reads/fields/`)
      .pipe(map((response: any) => new LprReadsFieldsModel(response)));
  }

  public getReads(
    params?: IFsLprReadsParameters,
  ): Observable<LprReadsModel | { query_id: string }> {
    if (!this._api) {
      console.warn('LPR API is disabled or not configured');
      return of(
        new LprReadsModel({
          pages: 0,
          page: 1,
          size: 0,
          total: 0,
          items: [],
        }),
      );
    }

    Object.keys(params).forEach((param) => {
      if (params[param] === null || params[param] === undefined) {
        delete params[param];
      }
    });

    // note: object params can be passed into httpClient instead of HttpParams
    return this._httpClient.get(`${this._api}/api/reads/`, { params: params as any }).pipe(
      map((response: any) => {
        if (response.query_id) {
          return {
            query_id: response.query_id,
          };
        }
        return new LprReadsModel(response);
      }),
    );
  }

  public getReadById(readId: string, params?: ISnListQueryParameters): Observable<LprReadModel> {
    if (!this._api) {
      console.warn('LPR API is disabled or not configured');
      return of(new LprReadModel({}));
    }

    return this._httpClient
      .get(`${this._api}/api/reads/${readId}/`, { params })
      .pipe(map((response: any) => new LprReadModel(response)));
  }

  public addToVault(vaultId: string, readId: string, queryId?: string): Observable<any> {
    const data = {
      vaultId,
      readId,
      queryId,
    };
    return this._httpClient.post('/api/lpr/reads/add-to-vault/', data);
  }
}
